import produce from 'immer'
import React, { useMemo, useCallback } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { STATUS } from 'react-joyride'
import LoadableVisibility from 'react-loadable-visibility/react-loadable'

const Joyride = LoadableVisibility({
  loader: () => import('react-joyride'),
  loading: 'div'
})

function TourTooltip ({ steps, onComplete, ...otherProps }) {
  const revisedSteps = useMemo(() => (produce(steps, draft => {
    draft[0] = {
      disableBeacon: true,
      ...draft[0]
    }
  })), [steps])

  const callback = useCallback(
    ({ status }) => {
      if (status === STATUS.FINISHED && onComplete) {
        onComplete()
      }
    },
    [onComplete]
  )

  const styles = useMemo(() => ({ options: {
    primaryColor: 'var(--primary2)'
  } }), [])

  return (
    <Joyride steps={revisedSteps} run continuous={revisedSteps.length > 1} disableOverlayClose showProgress disableScrollParentFix callback={callback} styles={styles} {...otherProps} />
  )
}

export default TourTooltip
